export class RegexValidator {
    constructor(message, regex) {
        this.message = message;
        this.regex = new RegExp(regex);
    }
    validate(field) {
        return this.regex.test(field);
    }
}
//# sourceMappingURL=RegexValidator.js.map